import {FC, SVGProps} from 'react';

export const PhotoRemoveIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<rect width="32" height="32" fill="#E4E4E4" />
		<rect x="8" y="11" width="16" height="1.6" fill="black" />
		<rect x="13" y="8" width="6" height="1.6" fill="black" />
		<path d="M21.0879 11.7998L19.584 23.2002H12.416L10.9121 11.7998H21.0879Z" stroke="black" strokeWidth="1.6" />
	</svg>
);
